const firebaseConfig = {
    apiKey: "AIzaSyAHsTHzEirInU5s0VCI_NfrlSmY3z61Oz4",
    authDomain: "creative-agency-a1c8c.firebaseapp.com",
    databaseURL: "https://creative-agency-a1c8c.firebaseio.com",
    projectId: "creative-agency-a1c8c",
    storageBucket: "creative-agency-a1c8c.appspot.com",
    messagingSenderId: "550015873458",
    appId: "1:550015873458:web:e9c5c08d2ce663ad0bb4ab"
  };
  export default firebaseConfig;